import React, { useEffect, useState } from "react";
// import TextField from "../../../../components/inputs/textfield";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import { FormValidate } from "../../../components/formValidate";
import "./view.css";
import CommonForm from "../../../components/commonform/commonForm";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { vendorPaymentInitiate } from "../../admin/admin.api";
import moment from "moment";

export default function AddSpaceparkAdvisors(props) {
  const [formData, setFormData] = useState({});
  let required = ["tran_id", "amount", "payment_mode", "tran_date"];
  const today = new Date();
  const { id } = useParams();
  const [snackMessage, setSnackMessage] = useState("");
  const [dropdata, setDropdata] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [err, setErr] = useState(false);
  const [keyvalue, setKeyValue] = useState(1);
  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    let data = formData;
    data = { ...data, [name]: value };
    setFormData(data);
  };

  const handleDatePickerChange = (e, name) => {
    let date = e.value;
    const dateRegex = /^[0-9]{2}-[0-9]{2}-[0-9]{4}$/;
    if (dateRegex.test(date)) {
      setErr(false);
    } else {
      setErr(true);
    }
    setFormData({ ...formData, [name]: date });
    setKeyValue(keyvalue + 1);
  };
  const handlePhoneNumberChange = (e) => {
    //
    let name = e.target.name;
    let value = e.target.value;
    //
    //

    let newValue = value.replace(/[^0-9]/g, "");
    let data = formData;
    data = {
      ...data,

      [name]: newValue,
    };
    setFormData(data);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = FormValidate(formData, required);
    setIsActive(true);
    if (Object.keys(errors).length === 0) {
      const sendData = {
        amount: formData?.amount,
        tran_id: formData?.tran_id,
        utr_no: formData?.utr_no,
        bank_name: formData?.bank_name,
        payment_mode: formData?.payment_mode,
        tran_date: moment(formData?.tran_date, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        ),
      };

      // form.append("link", formData.link);
      console.log(id, sendData);
      vendorPaymentInitiate(id, sendData)
        .then((res) => {
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
          setIsActive(false);
        })
        .catch((error) => {
          setSnackMessage(error.message);
          setIsSnackError(true);
          setSnackOpen(true);
          setIsActive(false);
        });
    } else {
      setSnackMessage("Please fill all mandatory fields");
      setIsSnackError(true);
      setSnackOpen(true);
      setIsActive(false);
    }
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/");
    }
  };

  console.log(formData);
  return (
    <div className="d-flex justify-content-center">
    <div className="add-per container-vendorPayment">
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container py-5 ">
        <div className="vendorPayment-title">Vendor Payment Verification</div>
        <hr />

        <div className="row">
          <div className=" ">
            <TextField
              fullwidth
              label="Transaction Id"
              required
              value={formData.tran_id ?? ""}
              onChange={(e) => handleChange(e)}
              name="tran_id"
              id="tran_id"
              aria-describedby="emailHelp"
            />
          </div>

          <div className=" ">
            <TextField
              fullwidth
              label="Unique Transaction Reference (UTR No.)"
              value={formData.utr_no ?? ""}
              onChange={(e) => handleChange(e)}
              name="utr_no"
              id="utr_no"
              aria-describedby="emailHelp"
            />
          </div>

          <div className="">
            <TextField
              required
              label="Amount"
              onChange={(e) => handlePhoneNumberChange(e)}
              name="amount"
              value={formData.amount}
              aria-describedby="emailHelp"
              fullwidth
            />
          </div>
          <div className="">
            <TextField
              label="Name of the Bank"
              onChange={(e) => handleChange(e)}
              name="bank_name"
              value={formData.bank_name}
              fullwidth
            />
          </div>
          <div className="">
            <TextField
              required
              label="Mode of Payment"
              onChange={(e) => handleChange(e)}
              name="payment_mode"
              value={formData.payment_mode}
              fullwidth
            />
          </div>
          <div className="">
            <CommonForm
              fieldType="date"
              label={`Transaction Date`}
              required
              name="tran_date"
              maxDate={today}
              value={formData?.tran_date ?? ""}
              onChange={(e) => {
                handleDatePickerChange(e, "tran_date");
              }}
              {...props}
            />
            {err && (
              <div className="file-up-helper mt-1">
                Please select a valid date
              </div>
            )}
          </div>

          <div className="mt-4">
            <center>
              <button
                type="button"
                className="btn btn-dark mt-3"
                onClick={(e) => handleSubmit(e)}
              >
                Submit
              </button>
            </center>
          </div>
          {/* ---------------- */}
        </div>
      </div>
    </div>
    </div>
  );
}
